import { Toaster as Sonner, toast } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

interface CustomToasterProps extends Omit<ToasterProps, 'theme'> {
  theme?: 'light' | 'dark' | 'system'
}

const Toaster = ({ theme, ...props }: CustomToasterProps) => {
  // Get theme from props or check DOM
  let currentTheme: 'light' | 'dark' | 'system' = theme || 'system'

  if (!theme && typeof document !== 'undefined') {
    currentTheme = document.documentElement.classList.contains('dark') ? 'dark' : 'light'
  }

  return (
    <Sonner
      theme={currentTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
